<template>
  <div class="public-view-form-container" :style="{ height }">
    <div v-if="isShowFilter" ref="public_view_filter" class="public-view-filter">
      <el-select v-model="fliter_config.value" v-bind="fliter_config.props">
        <el-option
          v-for="item in fliter_config.options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </div>
    <el-scrollbar
      class="form-scrollbar-wrapper"
      wrap-style="overflow-x:hidden;"
      :style="{ height: scrollbar_height }"
    >
      <div v-for="(item, index) in view_list" :key="index" class="w-full cursor-pointer view-form-item">
        <el-tooltip :disabled="!showDelBtn" effect="dark" :content="item[formFields.selection_config.label_key]" placement="top-start">
          <div class="truncate flex-1">
            {{ item[formFields.selection_config.label_key] }}
          </div>
        </el-tooltip>
        <div class="flex-grow-0 title-action">
          <slot :item="item" :index="index" name="action" />
          <i v-if="showDelBtn" class="el-icon-delete font-16" @click="onDel(item)" />
        </div>
      </div>
      <el-empty v-show="formFields.selection_config.list.length === 0" v-bind="empty_config.props" />
    </el-scrollbar>
  </div>
</template>

<script>
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';

export default {
  mixins: [data_sharing_mixin],
  props: {
    /** 表单配置 */
    formFields: {
      type: Object,
      default() {
        return {};
      },
    },
    /** 是否显示删除按钮 */
    showDelBtn: {
      type: Boolean,
      default: true,
    },
    /** 容器高度 */
    height: {
      type: String,
      default: '400px',
    },
    /** 是否显示过滤器 */
    isShowFilter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      /** 过滤项配置 */
      fliter_config: {
        value: '',
        options: [],
        props: {
          size: 'mini',
        },
        on: {
          change: () => {},
        },
      },
      /** 空数据配置 */
      empty_config: {
        props: {
          description: '暂无配置',
        },
      },
      /** 滚动条高度 */
      scrollbar_height: '100%',
    };
  },
  computed: {
    /**
     * 展示数据列表
     * @returns {Object[]}
     */
    view_list() {
      if (!this.isShowFilter) {
        return this.formFields.selection_config.list;
      }
      return this.formFields.selection_config.list.filter(item => item.advertiser_id === this.fliter_config.value);
    },
  },
  mounted() {
    this.initFilterConfig();
  },
  methods: {
    /**
     * 删除
     * @param {Object} item 数据项
     * @returns {void}
     */
    onDel(item) {
      const { unique_key, advertiser_id_key = null, list } = this.formFields.selection_config;
      const id = item[unique_key];
      const advertiser_id = advertiser_id_key ? item[advertiser_id_key] : null;
      /**
       * 匹配规则
       * - 不存在广告账户ID，通过唯一键匹配
       * - 存在广告账户ID，通过唯一键 + 广告账户ID匹配 - 部分数据（如落地页）会存在多个广告账户共用一个数据的情况
       */
      const index = list.findIndex(i => i[unique_key] === id && (!advertiser_id || i[advertiser_id_key] === advertiser_id));
      list.splice(index, 1);
    },
    /**
     * 初始化过滤配置
     * @returns {void}
     */
    initFilterConfig() {
      if (this.isShowFilter) {
        // 初始化过滤配置
        const default_options = this.getAdvertiserOptions();
        Object.assign(this.fliter_config, { options: default_options, value: default_options[0].value });

        // 初始化滚动条高度 - 减去过滤项的高度
        const filter_height = this.$refs.public_view_filter?.offsetHeight || 0;
        this.scrollbar_height = `calc(100% - ${filter_height}px)`;
      }
    },
    /**
     * 获取广告账户选项
     * @returns {Object[]}
     */
    getAdvertiserOptions() {
      const { campaign_config } = this.local_sharing_data.getFormFields();
      const { delivery_form } = campaign_config.config;
      const { fusion__channel_code } = delivery_form.config;
      const { fusion__channel_codes } = fusion__channel_code.children;
      return fusion__channel_codes.value.map(({ label, advertiser_id }) => {
        return {
          label,
          value: advertiser_id,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.public-view-form-container {
  .public-view-filter {
    padding: 5px;
  }
  .form-scrollbar-wrapper {
    .view-form-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      border-bottom: 1px solid #ebeef5;
      transition: background-color 0.25s ease;
      padding: 16px 20px;
      &:hover {
        background-color: #f5f7fa;
      }
      i {
        cursor: pointer;
        &:hover {
          color: #F56C6C;
        }
      }
    }
  }
}
</style>
